/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Remove_This_SetInputs */

const en_us2_workout_remove_this_set = /** @type {(inputs: Workout_Remove_This_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove this set`)
};

const pt_br2_workout_remove_this_set = /** @type {(inputs: Workout_Remove_This_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirar esta série`)
};

const es_419_workout_remove_this_set = /** @type {(inputs: Workout_Remove_This_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitar esta serie`)
};

const pt_pt2_workout_remove_this_set = /** @type {(inputs: Workout_Remove_This_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirar esta série`)
};

const fr_fr2_workout_remove_this_set = /** @type {(inputs: Workout_Remove_This_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer cette série`)
};

const de_de2_workout_remove_this_set = /** @type {(inputs: Workout_Remove_This_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesen Satz entfernen`)
};

const it_it2_workout_remove_this_set = /** @type {(inputs: Workout_Remove_This_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Togli questa serie`)
};

/**
* | output |
* | --- |
* | "Remove this set" |
*
* @param {Workout_Remove_This_SetInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_remove_this_set = /** @type {((inputs?: Workout_Remove_This_SetInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Remove_This_SetInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_remove_this_set(inputs)
	if (locale === "es-419") return es_419_workout_remove_this_set(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_remove_this_set(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_remove_this_set(inputs)
	if (locale === "de-DE") return de_de2_workout_remove_this_set(inputs)
	if (locale === "it-IT") return it_it2_workout_remove_this_set(inputs)
	return en_us2_workout_remove_this_set(inputs)
});
export { workout_remove_this_set as "workout.remove_this_set" }